import * as React from 'react';
import { CheckIcon, TruckIcon } from 'lucide-react';
import type { Trip } from 'contracts/tracking-v2/trips';
import { getTripDeliveryInfo } from 'pages/tracking-v2/utils/trip-utils';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<'div'> & {
  invoices: Trip['invoices'];
}

export const TripDeliveryStatusIcon = ({ invoices, className, ...props }: Props) => {
  const { deliveredRatio } = getTripDeliveryInfo(invoices);
  const Icon = deliveredRatio >= 1 ? CheckIcon : TruckIcon;

  return (
    <div
      {...props}
      className={cn(
        'rounded-full w-6 h-6 flex justify-center items-center text-slate-50',
        deliveredRatio >= 1 && 'bg-green-500',
        deliveredRatio < 1 && 'bg-orange-500',
        className,
      )}
    >
      <Icon className={'w-4 h-4'} />
    </div>
  );
};